var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisneyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89,
    height: 74,
    viewBox: "0 0 89 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_19",
    "data-name": "Rect\\xE1ngulo 19",
    width: 89,
    height: 74,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48",
    "data-name": "Trazado 48",
    d: "M48.815,20.983l-.153-.734c-.112-.535-.22-1.049-.31-1.567A15.464,15.464,0,0,1,55.844,2.144,17,17,0,0,1,68.915.657L67.693,5.445a12.074,12.074,0,0,0-9.411.994A10.5,10.5,0,0,0,53.2,17.833c.079.461.177.919.276,1.394l.16.771Z",
    fill: "#fdb54e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49",
    "data-name": "Trazado 49",
    d: "M.111,23.028c-.659-6.26,1.614-11.936,6.752-16.871A21.365,21.365,0,0,1,19.154.28,15.909,15.909,0,0,1,35.379,8.2,16.293,16.293,0,0,1,36.82,19.962l-4.8-1.1a11.318,11.318,0,0,0-.956-8.283,11.008,11.008,0,0,0-11.274-5.4,16.33,16.33,0,0,0-9.521,4.546C6.232,13.6,4.512,17.784,5.009,22.509Z",
    fill: "#fdb54e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50",
    "data-name": "Trazado 50",
    d: "M25.588,38.073a15.247,15.247,0,0,1-8.5-.432A12.277,12.277,0,0,1,8.579,26.8C7.954,20.844,10.388,16,14.585,11.97A18.9,18.9,0,0,1,25.491,6.758,13.433,13.433,0,0,1,39.24,13.415a13.842,13.842,0,0,1,1.2,10.025c-.069.3-.141.6-.239,1.024a25.9,25.9,0,0,1,17.047.054c-.158-.783-.322-1.5-.449-2.231A13.016,13.016,0,0,1,63.084,8.319a14.56,14.56,0,0,1,11.239-1.24A19.807,19.807,0,0,1,88.834,23.016a12.964,12.964,0,0,1-11.894,15.2,49.616,49.616,0,0,1-5.189-.087c2.6,6.23,3.81,14.111,1.409,20.587a19.277,19.277,0,0,1-1.913,3.718A24.393,24.393,0,0,1,48.854,73.965a27.643,27.643,0,0,1-14.835-5.031A24.5,24.5,0,0,1,24.37,55.075a25.452,25.452,0,0,1,1.219-17",
    fill: "#20221d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisneyIcon);
export default __webpack_public_path__ + "static/media/disneyIcon.dea5952d826419f4a8026f9e60120a5e.svg";
export { ForwardRef as ReactComponent };